// category — en. Canonical bazaar category display names.
// The KEY is the canonical English filter key stored in the database; the
// VALUE is what users read. Never translate the keys — products are matched
// against them.

export default {
  catHandmadeCrafts: 'Handmade Crafts',
  catFashion: 'Fashion',
  catFoodBeverage: 'Food & Beverage',
  catBeautyHealth: 'Beauty & Health',
  catHomeLiving: 'Home & Living',
  catSportsOutdoors: 'Sports & Outdoors',
  catBooksMedia: 'Books & Media',
  catServices: 'Services',
};